import React from 'react';
import { Box, IconButton } from '@wix/design-system';
import { More } from '@wix/wix-ui-icons-common';
import { observer } from 'mobx-react-lite';

export const CollectionActionsBar = observer(() => {
  return (
    <Box>
      <Box padding="SP1">
        <IconButton priority="secondary">
          <More />
        </IconButton>
      </Box>
    </Box>
  );
});
